//
// GTLModel.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "@sas-dvr/ltjs-commons/models/BaseModel";
import "@sas-dvr/ltjs-commons/styles/Style";

var GTLModel = createModule("gtl::GTLModel", ["commons::PropertyOwner","commons::BaseModel"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getStyle: [1],
        setStyle: [0,1],
        getDescription: [7,4],
    },
    ,
    ,
]);
export default GTLModel;
